import { FlagGatedRoute } from './flag-gated-route.component';
import { lazyRoute } from './lazy-route';

const ReportsListContainer = lazyRoute(() => import('pages/reports-list/reports-list.container'));

const ReportsList = () => (
  <FlagGatedRoute flag='P40_61669_reports_mfe_preview' testId='reports-list'>
    <ReportsListContainer />
  </FlagGatedRoute>
);

export default ReportsList;
